/**
 * Download a transcript as a paginated PDF (jsPDF loaded on demand).
 */
export class TranscriptPdfExporter {
  constructor({ documentBuilder } = {}) {
    this._builder = documentBuilder;
  }

  async export(conversation) {
    const { jsPDF } = await import("jspdf");
    const text = this._builder.build(conversation);
    const stem = this._builder.safeFileStem(conversation?.id || conversation?.visitorSessionId);
    const doc = new jsPDF({ unit: "pt", format: "a4" });
    const margin = 48;
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();
    const maxWidth = pageWidth - margin * 2;
    const lineHeight = 14;
    doc.setFont("helvetica", "normal");
    doc.setFontSize(10);
    const lines = doc.splitTextToSize(text, maxWidth);
    let y = margin;
    for (const line of lines) {
      if (y + lineHeight > pageHeight - margin) {
        doc.addPage();
        y = margin;
      }
      doc.text(line, margin, y);
      y += lineHeight;
    }
    doc.save(`${stem}.pdf`);
  }
}
